import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './AdminLayout.js';
import { Team } from './Team.js';
import { Clients } from './Clients.js';
import { Connections } from './Connections.js';
import { PortalUsers } from './PortalUsers.js';
import { Settings } from './Settings.js';
import { ScreenView } from '../../session/usage.js';
import { useFig } from '../../session/FigProvider.js';

/** The agency administration tree. Guarded by RequireRole ADMIN_ONLY in App.tsx. */
export function AdminHome() {
  const { client } = useFig();
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="team" replace />} />
        <Route path="team" element={<ScreenView api={client} name="team"><Team /></ScreenView>} />
        <Route path="clients" element={<ScreenView api={client} name="clients"><Clients /></ScreenView>} />
        <Route path="portal-users" element={<ScreenView api={client} name="portal-users"><PortalUsers /></ScreenView>} />
        <Route path="connections" element={<ScreenView api={client} name="connections"><Connections /></ScreenView>} />
        <Route path="settings" element={<ScreenView api={client} name="admin-settings"><Settings /></ScreenView>} />
      </Route>
    </Routes>
  );
}
